module.exports = __webpack_public_path__ + "img/c-bg-light.22552c1c.png";